// thousandSeparated(1234567) => "1 234 567"
// thousandSeparated(1234.56789) => "1 234,56789"
export function thousandSeparated(x) {
    var parts = x.toString().split(/[.,]/);
    var integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (!parts[1]) {
        return integerPart;
    }
    return "".concat(integerPart, ",").concat(parts[1]);
}
// accountNumberFormatted("12345678901") => "1234 56 78901"
// accountNumberFormatted("0234.56.78901") => "0234 56 78901"
export function accountNumberFormatted(x) {
    return nbsp(x
        .replace(/[^0-9]/g, '')
        .substring(0, 11)
        .replace(/(^\d{4})(\d)/, '$1 $2')
        .replace(/(^\d{4} \d\d)(\d)/, '$1 $2'));
}
// cleanCurrencyInput("  1 234,56 kr ") => "1234.56"
export function cleanCurrencyInput(x) {
    var withoutWhitespace = x.replace(/\s/g, '');
    var isNegative = withoutWhitespace.startsWith('-');
    var parts = withoutWhitespace.split(/[.,]/, 2);
    var integerPart = parts[0].replace(/[^0-9]/g, '');
    if (parts[1] === undefined) {
        return (isNegative ? '-' : '') + integerPart;
    }
    var decimalPart = parts[1].replace(/[^0-9]/g, '');
    return (isNegative ? '-' : '') + integerPart + '.' + decimalPart;
}
export function kr(s) {
    return nbsp(thousandSeparated(s !== null && s !== void 0 ? s : 0) + ' kr');
}
export function percent(s) {
    return nbsp(thousandSeparated(s !== null && s !== void 0 ? s : 0) + ' %');
}
// replace spaces with non-breaking ones
export function nbsp(s) {
    return s.replace(/ /g, '\u00a0'); // U+00A0 == &nbsp;
}
export function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
// pre-process by short-circuiting to just a dash on empty inputs
export function orDash(f) {
    return function (t) { return (t !== null && t !== undefined && t !== '' ? f(t) : '-'); };
}
